import { MAX_HOURS, MAX_MINUTES, MAX_DAYS } from 'utils/yup/schemas/getCreateNewRoom/getCreateNewRoom';

import { UnitsEnum } from '../utils';

export const getMaxAmountInputValue = (unit: UnitsEnum): number => {
  switch (unit) {
    case UnitsEnum.MINUTES:
      return MAX_MINUTES;
    case UnitsEnum.HOURS:
      return MAX_HOURS;
    case UnitsEnum.DAYS:
      return MAX_DAYS;
    default:
      throw new Error('Unsupported unit');
  }
};
